// auth.js
import globalPriceManager from '../utils/globalPriceManager';

const LOCAL_STORAGE_KEYS_TO_CLEAR = [
  'token',
  'refresh_token',
  'user',
  'tradeContext:accountId',
  'user:prefs',
  'app-style',
  'app-color-scheme',
  'app-bg-video',
  'valpha-platform-themes',
  'valpha-personal-themes',
  'valpha-theme-preference',
  'valpha-custom-styles',
  'valpha-custom-color-schemes',
  'ctrader_pending_internal_account_id',
  'ctrader_callback_temp_id',
];

const SESSION_STORAGE_KEYS_TO_CLEAR = [
  'valpha:auth-bootstrap-until',
  'ctrader_pending_internal_account_id',
];

const COOKIE_KEYS_TO_CLEAR = [
  'ctrader_pending_internal_account_id',
];

const clearStorageKeys = (storage, keys) => {
  if (!storage) return;
  keys.forEach((key) => {
    try { storage.removeItem(key); } catch (_) {}
  });
};

const clearCookie = (name) => {
  try {
    document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
  } catch (_) {}
};

export const logoutUser = () => {
    // --- Close all WebSocket connections BEFORE removing the token ---
    // 1. globalPriceManager: watchlist per-symbol price sockets
    try { globalPriceManager.closeAll(); } catch (_) {}

  // 2. Clear persisted auth and user-scoped UI state before notifying listeners.
  clearStorageKeys(localStorage, LOCAL_STORAGE_KEYS_TO_CLEAR);
  clearStorageKeys(sessionStorage, SESSION_STORAGE_KEYS_TO_CLEAR);
  COOKIE_KEYS_TO_CLEAR.forEach(clearCookie);

  // 3. Dispatch a 'valpha:logout' event so persistent providers can tear down
  //    sockets and reset in-memory state against an already-cleared storage layer.
  try { window.dispatchEvent(new Event('valpha:logout')); } catch (_) {}
};
  